export const MODULE = 'BILLING_BTAX';

export const UPLOAD = `${MODULE}/upload`;
export const LIST = `${MODULE}/list`;

export const COMPUTER_FEE_LIST = 'COMPUTER_FEE/list';
export const GENERATE_COMPUTER_FEE = 'GENERATE_COMPUTER_FEE/list';
export const GENERATE_AUDIT_LOG = 'GENERATE_AUDIT_LOG/list';
export const GENERATE_AGENCY_REPORT = 'GENERATE_AGENCY_REPORT';
export const AGENCY_REPORT_LIST = 'AGENCY_REPORT/list';
export const REPORT_FILTER = 'REPORT/filter';
export const REPORT_TYPES = 'REPORT/types';
export const GET_REPORT_ACCESS = 'GET_REPORT_ACCESS';

export const MODULE_TYPE = [
  {
    label: 'ALL',
    value: '',
  },
  {
    label: 'Real Property Tax',
    value: 'Real Property Tax (RPTAX)',
  },
  {
    label: 'Official Violation Receipt System',
    value: 'OVR - Ordinance Violation Receipt System',
  },
  { label: 'Business Tax', value: 'Business Tax (BTAX)' },
  {
    label: 'Community Tax Certificate',
    value: 'Community Tax Certificate CTC / CEDULA',
  },
  { label: 'Birth Certificate', value: 'Local Civil Registry' },
  {
    label: 'Occupational/Health Permits',
    value: 'Occupational Permit / Health Certificate',
  },
  {
    label: 'Business Permit and License Application (BPLS)',
    value: 'Business Permit and License Application (BPLS)',
  },
  {
    label: 'E-Boss',
    value: 'Business Permit Application (NEW & RENEWAL)',
  },
  {
    label: 'Notice of Violation',
    value: 'NOV - Notice of Violation',
  },
];

export const BPLS_MODULE_TYPE = [
  { label: 'ALL', value: '' },
  { label: 'Business Permit and License Application (BPLS)', value: 'BPLS' },
  { label: 'E-Boss', value: 'T_BPLS' },
];

export const STATUS_OPTIONS = [
  { label: 'ALL STATUS', value: '' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'FOR APPEARANCE', value: 'FOR APPEARANCE' },
  { label: 'FOR PRINTING', value: 'FOR PRINTING' },
  { label: 'FOR PICK-UP', value: 'FOR PICK-UP' },
  { label: 'APPROVED', value: 'APPROVED' },
  { label: 'WAITING FOR PAYMENT', value: 'WAITING FOR PAYMENT' },
  { label: 'FOR RESUBMISSION', value: 'FOR RESUBMISSION' },
  { label: 'REJECTED', value: 'REJECTED' },
  { label: 'FOR CHECKING', value: 'FOR CHECKING' },
  { label: 'RECEIVED', value: 'RECEIVED' },
  { label: 'PAID', value: 'PAID' },
  { label: 'PENDING LAB TEST', value: 'PENDING LAB TEST' },
  { label: 'FOR PRINTING', value: 'FOR PRINTING' },
  { label: 'PRINTED', value: 'PRINTED' },
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER' },
  { label: 'FOR DELIVERY', value: 'FOR DELIVERY' },
];

export const PAYMENT_STATUS = [
  { label: 'NULL', value: '' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'PAID', value: 'PAID' },
];

export const PAYMENT_STATUS_2 = [
  { label: 'ALL', value: '' },
  { label: 'UNPAID', value: 0 },
  { label: 'PAID', value: 1 },
];

export const TYPE_OF_PAYMENT = [
  'MANUAL PAYMENT',
  'CHECK PAYMENT',
  'ONLINE PAYMENT',
];

export const BPLS_TRANSACTION_TYPE = [
  { label: 'ALL', value: '' },
  { label: 'NEW', value: 'NEW' },
  { label: 'RENEWAL', value: 'RENEWAL' },
  { label: 'QUARTERLY', value: 'QUARTERLY' },
  { label: 'DELINQUENT', value: 'DELINQUENT' },
  { label: 'CHANGE', value: 'CHANGE' },
  { label: 'RETIREMENT', value: 'RETIREMENT' },
];

export const EBOSS_TRANSACTION_TYPE = [
  { label: 'ALL', value: '' },
  { label: 'NEW', value: 'NEW' },
  { label: 'RENEWAL', value: 'RENEWAL' },
  { label: 'QUARTERLY', value: 'QUARTERLY' },
  { label: 'DELINQUENT', value: 'DELINQUENT' },
];

export const RPTS_TRANSACTIONS = [
  { label: 'ALL', value: '' },
  { label: 'TAX PAYMENT', value: 'TAX PAYMENT' },
  { label: 'TAX CLEARANCE', value: 'TAX CLEARANCE' },
];

export const BTAX_TRANSACTIONS = [
  { label: 'ALL', value: '' },
  { label: 'TAX PAYMENT', value: 'TAX PAYMENT' },
];

export const PSA_TRANSACTIONS = [
  { label: 'ALL', value: '' },
  { label: 'BIRTH CERTIFICATE', value: 'BIRTH CERTIFICATE' },
  { label: 'MARRIAGE CERTIFICATE', value: 'MARRIAGE CERTIFICATE' },
  { label: 'DEATH CERTIFICATE', value: 'DEATH CERTIFICATE' },
];

export const CDL_TRANSACTIONS = [
  { label: 'ALL', value: '' },
  { label: 'INDIVIDUAL', value: 'INDIVIDUAL' },
  { label: 'CORPORATION', value: 'CORPORATION' },
];

export const OHP_TRANSACTIONS = [
  { label: 'ALL', value: '' },
  { label: 'NEW', value: 'NEW' },
  { label: 'RENEWAL', value: 'RENEWAL' },
];

export const OVRS_TRANSACTIONS = [
  { label: 'ALL', value: '' },
  { label: 'OVR PAYMENT', value: 'OVR PAYMENT' },
];

export const NOV_TRANSACTIONS = [{ label: 'ALL', value: '' }];

export const HC_TRANSACTIONS = [
  { label: 'ALL', value: '' },
  { label: 'NEW', value: 'NEW' },
  // { label: 'RENEWAL', value: 'RENEWAL' },
];

export const COMPUTER_FEE_TYPE = [
  { label: 'SUMMARY', value: 'SUMMARY' },
  { label: 'DETAILED', value: 'DETAILED' },
];

export const MODULE_TYPE_LIST = [
  { label: 'General', value: 'GENERAL' },
  { label: 'Birth Certificate Audit', value: 'BIRTH_CERTIFICATE_AUDIT' },
  { label: 'BPLS Audit', value: 'BPLS_AUDIT' },
  { label: 'Cedula Audit', value: 'CEDULA_AUDIT' },
  { label: 'Death Certificate Audit', value: 'DEATH_CERTIFICATE_AUDIT' },
  { label: 'Marriage Certificate Audit', value: 'MARRIAGE_CERTIFICATE_AUDIT' },
];

export const REPORT_TYPE = [
  {
    label: 'GENERAL ABSTRACT COLLECTION',
    value: 'GENERAL_ABSTRACT_COLLECTION',
  },
  {
    label: 'BARANGAY BUSINESS CLEARANCE DETAILED',
    value: 'BARANGAY_BUSINESS_CLEARANCE_DETAILED',
  },
  {
    label: 'BARANGAY BUSINESS CLEARANCE SUMMARIZED',
    value: 'BARANGAY_BUSINESS_CLEARANCE_SUMMARIZED',
  },
];

export const MODULES = [
  {
    label: 'BPLS',
    value: 'BPLS',
  },
  {
    label: 'LCR',
    value: 'LCR',
  },
  {
    label: 'CEDULA',
    value: 'CDL',
  },
];

export const PAYMENT_TYPE = [
  {
    label: 'ALL',
    value: '',
  },
  {
    label: 'CHECK PAYMENT',
    value: 'CHECK PAYMENT',
  },
  {
    label: 'MANUAL PAYMENT',
    value: 'MANUAL PAYMENT',
  },
  {
    label: 'ONLINE PAYMENT',
    value: 'ONLINE PAYMENT',
  },
];

export const DUMMY_REPORTS = [
  {
    date_generated: '2022-07-01',
    report_name: 'General Abstract Collection',
    module: 'bpls',
    start_date: '2022-07-01',
    end_date: '2022-07-01',
    status: 'pending',
  },
];
